<div class="container-fluid" style="height: calc(100% - 50px); padding: 20px;">
    <button mat-raised-button color="primary" (click)="addBlankRowAndEdit()">
        Add Client Id
    </button>
    <button style="margin-left: 1em;" mat-raised-button color="primary" (click)="saveClientEntries()">
        Save
    </button>
    <div class="row" style="height: calc(100% - 40px);">
        <app-custom-table class="ag-theme-material" class="collection-wrapper" [rowData]="gridApi_external_data"
            [columnDefs]="columnDefs_external" [hideGlobalFilter]="true" [animateRows]="true" [pagination]="true"
            [paginationPageSize]="20" (gridReady)="onGridReady($event)" 
            [showLoader]="showLoader">
        </app-custom-table>
    </div>
</div>
